<template>
    <div>
        <div  class="cookie-subscribe">
            <div class="container"  v-if="!cookie">


            <div class="row justify-content-center">
                <div class="col-lg-8 col-md-12 p-0">
                    <div class="cookie__blck">

                        <div class="content">
                            <div class="img">
                                <img src="/img/cookie.svg" alt="">
                            </div>
                            <div class="text">
                                <p class="min-min">Vi använder cookies: vilket hjälper sidan fungera bättre. Genom att fortsätta använda tjänsten godkänner du användandet av cookies. Läs mer: <a href="https://tecknael.se">https://tecknael.se</a></p>
                            </div>
                            <div class="close__blck" @click="setCookie">
                                <button class="close__btn">Jag förstår</button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            </div>


        </div>
    </div>
</template>

<script>
    export default {
        name: "CoockiesSubs",
        data: function(){
            return {
                cookie: false,
            }
        },
        methods: {
          checkCookie: function(){
              if (localStorage.cookieSubscribe === "true") {
                  this.cookie = true;
              }
          },
            setCookie: function(){
                this.cookie = true;
                localStorage.cookieSubscribe = true;
            }
        },
        mounted() {
           this.checkCookie();
        }

    }
</script>
